import { useUser } from "@/contexts/user";
import { useIsStaff } from "./useIsStaff";

/**
 * A hook to determine if the user is a partner.
 *
 * @returns A boolean indicating whether the user is a partner.
 */
export const useIsPartner = (): boolean => {
    const { user } = useUser();
    const isStaff = useIsStaff();
    const hasPartnerPermission =
        user?.permissions?.some((permission) =>
            permission.startsWith("partner_"),
        ) ?? false;

    return hasPartnerPermission && !isStaff;
};
